export const FETCH_CHANNELS = "FETCH_CHANNELS";
export const SET_MARKETING_CHANNELS_DATA = "SET_MARKETING_CHANNELS_DATA";
export const SET_AVAILABLE_CHANNELS = "SET_AVAILABLE_CHANNELS";
